<div class="container">

<section class="problems-section">
  <h2 class="main-title">Kennst du diese Probleme?</h2>
  
  <div class="problems-grid">
    <div *ngFor="let problem of problems" class="problem-card">
      <div class="icon">
        <i-feather [name]="problem.icon"></i-feather>
      </div>
      <h3>{{ problem.title }}</h3>
      <p>{{ problem.description }}</p>
    </div>
  </div>

  <div class="subtitle-section">
    <p>Dann gehörst du zu den 99% des Durchschnitts</p>
  </div>

  <div class="cta-section">
    <h2>Die Zeit ist gekommen...</h2>
    <h3>Zeig der Welt, was in dir steckt!</h3>
    
    <div class="content-grid">
      <div class="image-grid">
        <div class="grid-cell horizontal">
          <img src="https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2b10188f16b0ad4334314_benefit-img-horizontal-1.avif" alt="Ein Mann auf einer Ausichtsplattform" loading="lazy">
        </div>
        <div class="grid-cell">
          <img src="https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2b101d1dabbbb28f725b3_benefit-img-horizontal.avif" alt="Ein Mann im Club" loading="lazy">
        </div>
        <div class="grid-cell vertical">
          <img src="https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2b101bb07871299afaf2f_benefit-img-vertikal-2.avif" alt="Ein Mann auf einer Yacht" loading="lazy">
        </div>
        <div class="grid-cell vertical">
          <img src="https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2b1012b8e50b5f6687bf8_benefit-img-vertikal-1.avif" alt="Ein Mann vor einem Supercar" loading="lazy">
        </div>
        <div class="grid-cell">
          <img src="https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2b101432051639a870b53_benefit-img-horizontal-2.avif" alt="Ein Mann läuft durch eine Einkaufsstraße" loading="lazy">
        </div>
        <div class="grid-cell">
          <img src="https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2b101b89b0fef3a2e1883_benefit-img-vertikal.avif" alt="Ein Mann an einer Bar" loading="lazy">
        </div>
      </div>
      
      <div class="features-list">
        <h3>Du entscheidest, welchen Weg du wählst!</h3>
        <ul>
          <li>
            <i-feather name="check-circle"></i-feather>
            Lerne Schritt für Schritt, wie du dir ein skalierbares Online-Business aufbaust.
          </li>
          <li>
            <i-feather name="check-circle"></i-feather>
            Entdecke neue Möglichkeiten für deine persönliche Weiterentwicklung.
          </li>
          <li>
            <i-feather name="check-circle"></i-feather>
            Lerne, wie moderne Tools funktionieren und wie du sie selbstständig einsetzen kannst, um Prozesse klarer zu verstehen und effizienter zu gestalten.
          </li>
        </ul>
        
        <div class="cta-button">
          <app-apply-button [darkCounter]="true"></app-apply-button>
        </div>
      </div>
    </div>
  </div>
</section> 
</div>
